import * as types from './mutation-types'
import Vue from 'vue'
import deepEqual from 'deep-equal'
import { IGliderState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbGlider, IAloDbGliderConstParam } from '@/models/alodb/AloDbGlider'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { INextSurfacingDoConfig } from '@/models/iris/nextSurfacing/INextSurfacingDoConfig'
import { IFileTransfertConfig } from '@/models/iris/fileTransfert/IFileTransfertConfig'
import { ISingleWayPointConfig } from '@/models/iris/singleWayPoint/ISingleWayPointConfig'
import { IExpectedNMEAConfig } from '@/models/iris/expectedNMEA/IExpectedNMEAConfig'
import { WobAdminChanged } from '@/models/wob/WobAdminChanged'
import { IFileTransfert } from '@/models/iris/fileTransfert/IFileTransfert'
import { IFileTransfertMultiYo } from '@/models/iris/fileTransfert/IFileTransfertMultiYo'
import { IFtpConfig } from '@/models/iris/ftp/IFtpConfig'
import { IRsyncConfig } from '@/models/iris/rsync/IRsyncConfig'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations: MutationTree<IGliderState> = {
  //Gestion des recherches de glider
  [types.GLIDER_REQUEST]: state => {
    state.status = 'loading gliders'
    state.gliderLoading = true
  },
  [types.GLIDER_SUCCESS]: (state, gliders: Array<AloDbGlider>) => {
    state.status = 'success loading gliders'
    state.gliders = gliders
    state.gliderLoading = false
  },
  [types.GLIDER_ERROR]: state => {
    state.status = 'error loading gliders'
    state.gliders = []
    state.gliderLoading = false
  },
  [types.GLIDER_SELECT_DETAIL_REQUEST]: (state, itemId: number) => {
    state.status = `loading glider ${itemId}`
    state.gliderLoading = true
  },
  [types.GLIDER_SELECT_DETAIL_ERROR]: state => {
    state.status = 'error loading glider'
    state.gliderLoading = false
  },
  [types.GLIDER_SELECT_DETAIL_SUCCESS]: (state, glider: AloDbGlider) => {
    state.status = `success loading glider ${glider.GLI_ID}`
    //Mise à jour des références glider
    //1, on met à jour le glider dans la liste des gliders
    const index = state.gliders.findIndex(m => m.GLI_ID == glider.GLI_ID)
    state.gliders.splice(index == -1 ? state.gliders.length : index, index == -1 ? 0 : 1, glider)
    state.gliderLoading = false
  },
  [types.GLIDER_SELECT_DETAIL]: (state, glider: AloDbGlider) => {
    state.originalAdmGlider = glider
    state.modifiedAdmGlider = new AloDbGlider({
      ...glider,
      GLI_DATFAB: glider.GLI_DATFAB ? glider.GLI_DATFAB.toUTCString() : null,
    } as IAloDbGliderConstParam)
  },
  [types.GLIDER_UPDATE_MODIFIED_ADM]: (state, newProperties: Object) => {
    state.modifiedAdmGlider = { ...state.modifiedAdmGlider, ...newProperties }
  },
  [types.GLIDER_UPDATE_FILTER_ADM]: (state, newProperties: Object) => {
    state.adminFilter = { ...state.adminFilter, ...newProperties }
  },
  [types.GLIDER_IRIS_NSD_REQUEST]: state => {
    state.status = 'loading next surfacing config'
    state.nsdLoading = true
  },
  [types.GLIDER_IRIS_NSD_SUCCESS]: (
    state,
    { id, nsdConfig }: { id: number; nsdConfig: IrisConfigContainer<INextSurfacingDoConfig> },
  ) => {
    state.status = 'success loading next surfacing config'

    //si les config sont identique on met à jour les deux
    if (deepEqual(state.originalNsdConfigs[id], state.modifiedNsdConfigs[id])) {
      const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(nsdConfig)))
      Vue.set(state.modifiedNsdConfigs, id, cloneConfig)
    }
    Vue.set(state.originalNsdConfigs, id, nsdConfig)
    state.nsdLoading = false
  },
  [types.GLIDER_IRIS_NSD_ERROR]: state => {
    state.status = 'error loading next surfacing config'
    state.nsdLoading = false
  },
  [types.GLIDER_UPDATE_MODIFIED_NSD]: (state, { itemId, newProperties }: { itemId: number; newProperties: any }) => {
    const modifiedConfig = state.modifiedNsdConfigs[itemId].mod_settings
    if (newProperties.mod_settings?.hasOwnProperty('EnabledMOD'))
      modifiedConfig.EnabledMOD = newProperties.mod_settings.EnabledMOD
    if (newProperties.mod_settings?.NextSurfacingDo?.hasOwnProperty('exec_all_connect'))
      modifiedConfig.NextSurfacingDo.exec_all_connect = newProperties.mod_settings.NextSurfacingDo.exec_all_connect
    if (newProperties.mod_settings?.NextSurfacingDo?.hasOwnProperty('priority_listAction'))
      modifiedConfig.NextSurfacingDo.priority_listAction =
        newProperties.mod_settings.NextSurfacingDo.priority_listAction
    if (newProperties.mod_settings?.NextSurfacingDo_all?.hasOwnProperty('listAction'))
      modifiedConfig.NextSurfacingDo_all.listAction = newProperties.mod_settings.NextSurfacingDo_all.listAction
    if (newProperties.mod_settings?.NextSurfacingDo_next?.hasOwnProperty('listAction'))
      modifiedConfig.NextSurfacingDo_next.listAction = newProperties.mod_settings.NextSurfacingDo_next.listAction
    if (newProperties.mod_settings?.NextConnectDo?.hasOwnProperty('listAction')) {
      if (!modifiedConfig.NextConnectDo) Vue.set(modifiedConfig, 'NextConnectDo', { listAction: [] })
      modifiedConfig.NextConnectDo!.listAction = newProperties.mod_settings.NextConnectDo.listAction
    }
    //Vue.set(state.modifiedNsdConfigs,itemId,merge(state.modifiedNsdConfigs[itemId],newProperties))
  },
  [types.GLIDER_CANCEL_MODIFIED_NSD]: (state, itemId: number) => {
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(state.originalNsdConfigs[itemId])))
    Vue.set(state.modifiedNsdConfigs, itemId, cloneConfig)
  },
  [types.GLIDER_IRIS_NSD_SAVE_REQUEST]: state => {
    state.status = 'saving next surfacing config'
    state.nsdLoading = true
  },
  [types.GLIDER_IRIS_NSD_SAVE_SUCCESS]: (
    state,
    { id, nsdConfig }: { id: number; nsdConfig: IrisConfigContainer<INextSurfacingDoConfig> },
  ) => {
    state.status = 'success saving next surfacing config'
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(nsdConfig)))
    Vue.set(state.modifiedNsdConfigs, id, cloneConfig)
    Vue.set(state.originalNsdConfigs, id, nsdConfig)
    state.nsdLoading = false
  },
  [types.GLIDER_IRIS_NSD_SAVE_ERROR]: state => {
    state.status = 'error saving next surfacing config'
    state.nsdLoading = false
  },
  [types.GLIDER_DELETE_REQUEST]: (state, libelle: string) => {
    state.status = `deleting glider ${libelle}`
    state.gliderLoading = true
  },
  [types.GLIDER_DELETE_SUCCESS]: (state, gliId: number) => {
    state.status = `deleting glider ${gliId} successfully`
    const index = state.gliders.findIndex(g => g.GLI_ID == gliId)
    state.gliders.splice(index == -1 ? state.gliders.length : index, index == -1 ? 0 : 1)
    state.gliderLoading = false
  },
  [types.GLIDER_EXTERNAL_UPDATE]: (state, wob: WobAdminChanged<AloDbGlider>) => {
    //on met à jour ou ajoute l'objet dans la liste
    if (wob.actionType == 'Added' || wob.actionType == 'Modified') {
      //1, on met à jour de m'mission dans la liste des missions
      const index = state.gliders.findIndex(g => g.GLI_ID == wob.newAloDbItem.GLI_ID)
      state.gliders.splice(index == -1 ? state.gliders.length : index, index == -1 ? 0 : 1, wob.newAloDbItem)
      if (state.originalAdmGlider.GLI_ID == wob.newAloDbItem.GLI_ID) {
        if (deepEqual(state.originalAdmGlider, state.modifiedAdmGlider)) {
          state.modifiedAdmGlider = new AloDbGlider(wob.newAloDbItem as IAloDbGliderConstParam)
        }
        state.originalAdmGlider = wob.newAloDbItem
      }
    }
    //on supprime l'objet de la liste si existant
    else if (wob.actionType == 'Deleted') {
      const index = state.gliders.findIndex(g => g.GLI_ID == wob.oldAloDbItem.GLI_ID)
      state.gliders.splice(index == -1 ? state.gliders.length : index, index == -1 ? 0 : 1)
    }
  },
  [types.GLIDER_DELETE_ERROR]: state => {
    state.status = 'error de suppression glider'
    state.gliderLoading = false
  },
  [types.GLIDER_IRIS_FILE_TRANSFERT_REQUEST]: state => {
    state.status = 'loading file transfer config'
    state.fileTransfertLoading = true
  },
  [types.GLIDER_IRIS_FILE_TRANSFERT_SUCCESS]: (
    state,
    { id, fileTransfertConfig }: { id: number; fileTransfertConfig: IrisConfigContainer<IFileTransfertConfig> },
  ) => {
    state.status = 'success loading file transfer config'
    //console.log("File equal",deepEqual(state.originalFileTransfertConfigs[id],state.modifiedFileTransfertConfigs[id]),state.originalFileTransfertConfigs[id],state.modifiedFileTransfertConfigs[id])
    //si les config sont identique on met à jour les deux
    if (deepEqual(state.originalFileTransfertConfigs[id], state.modifiedFileTransfertConfigs[id])) {
      const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(fileTransfertConfig)))
      Vue.set(state.modifiedFileTransfertConfigs, id, cloneConfig)
    }
    Vue.set(state.originalFileTransfertConfigs, id, fileTransfertConfig)
    state.fileTransfertLoading = false
  },
  [types.GLIDER_IRIS_FILE_TRANSFERT_ERROR]: state => {
    state.status = 'error loading file transfer config'
    state.fileTransfertLoading = false
  },
  [types.GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT]: (
    state,
    { itemId, newProperties }: { itemId: number; newProperties: any },
  ) => {
    const modifierFileTransfert = state.modifiedFileTransfertConfigs[itemId]
    if (modifierFileTransfert) {
      const modifiedConfig = state.modifiedFileTransfertConfigs[itemId].mod_settings
      if (newProperties.mod_settings?.hasOwnProperty('EnabledMOD'))
        modifiedConfig.EnabledMOD = newProperties.mod_settings.EnabledMOD
      if (newProperties.mod_settings?.FileTransfer?.hasOwnProperty('priority_transferType')) {
        if (!modifiedConfig.FileTransfer) modifiedConfig.FileTransfer = {} as IFileTransfert
        modifiedConfig.FileTransfer.priority_transferType =
          newProperties.mod_settings.FileTransfer.priority_transferType
      }
      if (newProperties.mod_settings?.FileTransfer_multiYo?.hasOwnProperty('first_file')) {
        if (!modifiedConfig.FileTransfer_multiYo) modifiedConfig.FileTransfer_multiYo = {} as IFileTransfertMultiYo
        modifiedConfig.FileTransfer_multiYo.first_file = newProperties.mod_settings.FileTransfer_multiYo.first_file
      }
      if (newProperties.mod_settings?.FileTransfer_multiYo?.hasOwnProperty('last_file')) {
        if (!modifiedConfig.FileTransfer_multiYo) modifiedConfig.FileTransfer_multiYo = {} as IFileTransfertMultiYo
        modifiedConfig.FileTransfer_multiYo.last_file = newProperties.mod_settings.FileTransfer_multiYo.last_file
      }
      if (newProperties.mod_settings?.FileTransfer_listFile?.hasOwnProperty('list_file'))
        modifiedConfig.FileTransfer_listFile.list_file = newProperties.mod_settings.FileTransfer_listFile.list_file
      if (newProperties.mod_settings?.FileTransfer_listFile?.hasOwnProperty('list_file_nf'))
        modifiedConfig.FileTransfer_listFile.list_file_nf =
          newProperties.mod_settings.FileTransfer_listFile.list_file_nf
      if (newProperties.mod_settings?.FileTransfer_standard?.hasOwnProperty('caught_old_file_nav'))
        modifiedConfig.FileTransfer_standard.caught_old_file_nav =
          newProperties.mod_settings.FileTransfer_standard.caught_old_file_nav
      if (newProperties.mod_settings?.FileTransfer_standard?.hasOwnProperty('caught_old_file_sci'))
        modifiedConfig.FileTransfer_standard.caught_old_file_sci =
          newProperties.mod_settings.FileTransfer_standard.caught_old_file_sci
      if (newProperties.mod_settings?.FileTransfer_standard?.hasOwnProperty('nb_file_nav'))
        modifiedConfig.FileTransfer_standard.nb_file_nav = newProperties.mod_settings.FileTransfer_standard.nb_file_nav
      if (newProperties.mod_settings?.FileTransfer_standard?.hasOwnProperty('nb_file_sci'))
        modifiedConfig.FileTransfer_standard.nb_file_sci = newProperties.mod_settings.FileTransfer_standard.nb_file_sci
    }
  },
  [types.GLIDER_CANCEL_MODIFIED_FILE_TRANSFERT]: (state, itemId: number) => {
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(state.originalFileTransfertConfigs[itemId])))
    Vue.set(state.modifiedFileTransfertConfigs, itemId, cloneConfig)
  },
  [types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST]: state => {
    state.status = 'saving file transfer config'
    state.fileTransfertLoading = true
  },
  [types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_SUCCESS]: (
    state,
    { id, fileTransfertConfig }: { id: number; fileTransfertConfig: IrisConfigContainer<IFileTransfertConfig> },
  ) => {
    state.status = 'success saving file transfer config'
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(fileTransfertConfig)))
    Vue.set(state.modifiedFileTransfertConfigs, id, cloneConfig)
    Vue.set(state.originalFileTransfertConfigs, id, fileTransfertConfig)
    state.fileTransfertLoading = false
  },
  [types.GLIDER_IRIS_FILE_TRANSFERT_SAVE_ERROR]: state => {
    state.status = 'error saving file transfer config'
    state.fileTransfertLoading = false
  },
  [types.GLIDER_IRIS_SINGLE_WAY_POINT_REQUEST]: state => {
    state.status = 'loading single way point config'
    state.singleWayPointLoading = true
  },
  [types.GLIDER_IRIS_SINGLE_WAY_POINT_SUCCESS]: (
    state,
    { id, singleWayPointConfig }: { id: number; singleWayPointConfig: IrisConfigContainer<ISingleWayPointConfig> },
  ) => {
    state.status = 'success loading single way point config'

    //si les config sont identique on met à jour les deux
    if (deepEqual(state.originalSingleWayPointConfigs[id], state.modifiedSingleWayPointConfigs[id])) {
      const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(singleWayPointConfig)))
      Vue.set(state.modifiedSingleWayPointConfigs, id, cloneConfig)
    }
    Vue.set(state.originalSingleWayPointConfigs, id, singleWayPointConfig)
    state.singleWayPointLoading = false
  },
  [types.GLIDER_IRIS_SINGLE_WAY_POINT_ERROR]: state => {
    state.status = 'error loading single way point config'
    state.singleWayPointLoading = false
  },
  [types.GLIDER_UPDATE_MODIFIED_SINGLE_WAY_POINT]: (
    state,
    { itemId, newProperties }: { itemId: number; newProperties: any },
  ) => {
    const modifiedConfig = state.modifiedSingleWayPointConfigs[itemId].mod_settings
    if (newProperties.mod_settings?.hasOwnProperty('EnabledMOD'))
      modifiedConfig.EnabledMOD = newProperties.mod_settings.EnabledMOD
    if (newProperties.mod_settings?.SingleWayPoint_target?.hasOwnProperty('heading_deadzone'))
      modifiedConfig.SingleWayPoint_target.heading_deadzone = Number(
        newProperties.mod_settings.SingleWayPoint_target.heading_deadzone,
      )
    if (newProperties.mod_settings?.SingleWayPoint_target?.hasOwnProperty('lat_target'))
      modifiedConfig.SingleWayPoint_target.lat_target = Number(
        newProperties.mod_settings.SingleWayPoint_target.lat_target,
      )
    if (newProperties.mod_settings?.SingleWayPoint_target?.hasOwnProperty('lon_target'))
      modifiedConfig.SingleWayPoint_target.lon_target = Number(
        newProperties.mod_settings.SingleWayPoint_target.lon_target,
      )
    //Vue.set(state.SingleWayPoint_target,itemId,merge(state.modifiedNsdConfigs[itemId],newProperties))
  },
  [types.GLIDER_CANCEL_MODIFIED_SINGLE_WAY_POINT]: (state, itemId: number) => {
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(state.originalSingleWayPointConfigs[itemId])))
    Vue.set(state.modifiedSingleWayPointConfigs, itemId, cloneConfig)
  },
  [types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_REQUEST]: state => {
    state.status = 'saving single way point config'
    state.singleWayPointLoading = true
  },
  [types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_SUCCESS]: (
    state,
    { id, singleWayPointConfig }: { id: number; singleWayPointConfig: IrisConfigContainer<ISingleWayPointConfig> },
  ) => {
    state.status = 'success saving single way point config'
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(singleWayPointConfig)))
    Vue.set(state.modifiedSingleWayPointConfigs, id, cloneConfig)
    Vue.set(state.originalSingleWayPointConfigs, id, singleWayPointConfig)
    state.singleWayPointLoading = false
  },
  [types.GLIDER_IRIS_SINGLE_WAY_POINT_SAVE_ERROR]: state => {
    state.status = 'error saving single way point config'
    state.singleWayPointLoading = false
  },
  [types.GLIDER_IRIS_FTP_REQUEST]: state => {
    state.status = 'loading ftp config'
    state.ftpLoading = true
  },
  [types.GLIDER_IRIS_FTP_SUCCESS]: (
    state,
    { id, ftpConfig }: { id: number; ftpConfig: IrisConfigContainer<IFtpConfig> },
  ) => {
    state.status = 'success loading ftp config'

    //si les config sont identique on met à jour les deux
    if (deepEqual(state.originalFtpConfigs[id], state.modifiedFtpConfigs[id])) {
      const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(ftpConfig)))
      Vue.set(state.modifiedFtpConfigs, id, cloneConfig)
    }
    Vue.set(state.originalFtpConfigs, id, ftpConfig)
    state.ftpLoading = false
  },
  [types.GLIDER_IRIS_FTP_ERROR]: state => {
    state.status = 'error loading ftp config'
    state.ftpLoading = false
  },
  [types.GLIDER_UPDATE_MODIFIED_FTP]: (state, { itemId, newProperties }: { itemId: number; newProperties: any }) => {
    const modifiedConfig = state.modifiedFtpConfigs[itemId].mod_settings
    if (newProperties.mod_settings?.hasOwnProperty('EnabledMOD'))
      modifiedConfig.EnabledMOD = newProperties.mod_settings.EnabledMOD
    if (newProperties.mod_settings?.Data?.hasOwnProperty('dst_paths'))
      modifiedConfig.Data.dst_paths = newProperties.mod_settings.Data.dst_paths
    if (newProperties.mod_settings?.Data?.hasOwnProperty('sync_paths'))
      modifiedConfig.Data.sync_paths = newProperties.mod_settings.Data.sync_paths

    if (newProperties.mod_settings?.FTP?.hasOwnProperty('login'))
      modifiedConfig.FTP.login = newProperties.mod_settings.FTP.login
    if (newProperties.mod_settings?.FTP?.hasOwnProperty('password'))
      modifiedConfig.FTP.password = newProperties.mod_settings.FTP.password
    if (newProperties.mod_settings?.FTP?.hasOwnProperty('port'))
      modifiedConfig.FTP.port = Number(newProperties.mod_settings.FTP.port)
    if (newProperties.mod_settings?.FTP?.hasOwnProperty('server'))
      modifiedConfig.FTP.server = newProperties.mod_settings.FTP.server
    if (newProperties.mod_settings?.FTP?.hasOwnProperty('tls'))
      modifiedConfig.FTP.tls = newProperties.mod_settings.FTP.tls
  },
  [types.GLIDER_CANCEL_MODIFIED_FTP]: (state, itemId: number) => {
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(state.originalFtpConfigs[itemId])))
    Vue.set(state.modifiedFtpConfigs, itemId, cloneConfig)
  },
  [types.GLIDER_IRIS_FTP_SAVE_REQUEST]: state => {
    state.status = 'saving ftp config'
    state.ftpLoading = true
  },
  [types.GLIDER_IRIS_FTP_SAVE_SUCCESS]: (
    state,
    { id, ftpConfig }: { id: number; ftpConfig: IrisConfigContainer<IFtpConfig> },
  ) => {
    state.status = 'success saving ftp config'
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(ftpConfig)))
    Vue.set(state.modifiedFtpConfigs, id, cloneConfig)
    Vue.set(state.originalFtpConfigs, id, ftpConfig)
    state.ftpLoading = false
  },
  [types.GLIDER_IRIS_FTP_SAVE_ERROR]: state => {
    state.status = 'error saving ftp config'
    state.ftpLoading = false
  },
  [types.GLIDER_IRIS_RSYNC_REQUEST]: state => {
    state.status = 'loading rsync config'
    state.rsyncLoading = true
  },
  [types.GLIDER_IRIS_RSYNC_SUCCESS]: (
    state,
    { id, rsyncConfig }: { id: number; rsyncConfig: IrisConfigContainer<IRsyncConfig> },
  ) => {
    state.status = 'success loading rsync config'

    //si les config sont identique on met à jour les deux
    if (deepEqual(state.originalRsyncConfigs[id], state.modifiedRsyncConfigs[id])) {
      const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(rsyncConfig)))
      Vue.set(state.modifiedRsyncConfigs, id, cloneConfig)
    }
    Vue.set(state.originalRsyncConfigs, id, rsyncConfig)
    state.rsyncLoading = false
  },
  [types.GLIDER_IRIS_RSYNC_ERROR]: state => {
    state.status = 'error loading rsync config'
    state.rsyncLoading = false
  },
  [types.GLIDER_UPDATE_MODIFIED_RSYNC]: (state, { itemId, newProperties }: { itemId: number; newProperties: any }) => {
    const modifiedConfig = state.modifiedRsyncConfigs[itemId].mod_settings
    if (newProperties.mod_settings?.hasOwnProperty('EnabledMOD'))
      modifiedConfig.EnabledMOD = newProperties.mod_settings.EnabledMOD
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('dst_paths'))
      modifiedConfig.RSync_remote.dst_paths = newProperties.mod_settings.RSync_remote.dst_paths
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('login'))
      modifiedConfig.RSync_remote.login = newProperties.mod_settings.RSync_remote.login
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('password'))
      modifiedConfig.RSync_remote.password = newProperties.mod_settings.RSync_remote.password
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('port'))
      modifiedConfig.RSync_remote.port = Number(newProperties.mod_settings.RSync_remote.port)
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('private_key'))
      modifiedConfig.RSync_remote.private_key = newProperties.mod_settings.RSync_remote.private_key
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('server'))
      modifiedConfig.RSync_remote.server = newProperties.mod_settings.RSync_remote.server
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('sftp'))
      modifiedConfig.RSync_remote.sftp = newProperties.mod_settings.RSync_remote.sftp
    if (newProperties.mod_settings?.RSync_remote?.hasOwnProperty('sync_paths'))
      modifiedConfig.RSync_remote.sync_paths = newProperties.mod_settings.RSync_remote.sync_paths
  },
  [types.GLIDER_CANCEL_MODIFIED_RSYNC]: (state, itemId: number) => {
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(state.originalRsyncConfigs[itemId])))
    Vue.set(state.modifiedRsyncConfigs, itemId, cloneConfig)
  },
  [types.GLIDER_IRIS_RSYNC_SAVE_REQUEST]: state => {
    state.status = 'saving rsync config'
    state.rsyncLoading = true
  },
  [types.GLIDER_IRIS_RSYNC_SAVE_SUCCESS]: (
    state,
    { id, rsyncConfig }: { id: number; rsyncConfig: IrisConfigContainer<IRsyncConfig> },
  ) => {
    state.status = 'success saving rsync config'
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(rsyncConfig)))
    Vue.set(state.modifiedRsyncConfigs, id, cloneConfig)
    Vue.set(state.originalRsyncConfigs, id, rsyncConfig)
    state.rsyncLoading = false
  },
  [types.GLIDER_IRIS_RSYNC_SAVE_ERROR]: state => {
    state.status = 'error saving rsync config'
    state.rsyncLoading = false
  },
  [types.GLIDER_IRIS_EXPECTED_NMEA_REQUEST]: state => {
    state.status = 'loading expected nmea config'
    state.expectedNMEALoading = true
  },
  [types.GLIDER_IRIS_EXPECTED_NMEA_SUCCESS]: (
    state,
    { id, expectedNMEAConfig }: { id: number; expectedNMEAConfig: IrisConfigContainer<IExpectedNMEAConfig> },
  ) => {
    state.status = 'success loading expected nmea config'

    //si les config sont identique on met à jour les deux
    if (deepEqual(state.originalExpectedNMEAConfigs[id], state.modifiedExpectedNMEAConfigs[id])) {
      const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(expectedNMEAConfig)))
      Vue.set(state.modifiedExpectedNMEAConfigs, id, cloneConfig)
    }
    Vue.set(state.originalExpectedNMEAConfigs, id, expectedNMEAConfig)
    state.expectedNMEALoading = false
  },
  [types.GLIDER_IRIS_EXPECTED_NMEA_ERROR]: state => {
    state.status = 'error loading expected nmea config'
    state.expectedNMEALoading = false
  },
  [types.GLIDER_UPDATE_MODIFIED_EXPECTED_NMEA]: (
    state,
    { itemId, newProperties }: { itemId: number; newProperties: any },
  ) => {
    const modifiedConfig = state.modifiedExpectedNMEAConfigs[itemId].mod_settings
    if (newProperties.mod_settings?.ExpectedNMEA?.hasOwnProperty('auto_go'))
      modifiedConfig.ExpectedNMEA.auto_go = newProperties.mod_settings.ExpectedNMEA.auto_go
    //Vue.set(state.SingleWayPoint_target,itemId,merge(state.modifiedNsdConfigs[itemId],newProperties))
  },
  [types.GLIDER_CANCEL_MODIFIED_EXPECTED_NMEA]: (state, itemId: number) => {
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(state.originalExpectedNMEAConfigs[itemId])))
    Vue.set(state.modifiedExpectedNMEAConfigs, itemId, cloneConfig)
  },
  [types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_REQUEST]: state => {
    state.status = 'saving expected nmea config'
    state.expectedNMEALoading = true
  },
  [types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_SUCCESS]: (
    state,
    { id, expectedNMEAConfig }: { id: number; expectedNMEAConfig: IrisConfigContainer<IExpectedNMEAConfig> },
  ) => {
    state.status = 'success saving expected nmea config'
    const cloneConfig = new IrisConfigContainer(JSON.parse(JSON.stringify(expectedNMEAConfig)))
    Vue.set(state.modifiedExpectedNMEAConfigs, id, cloneConfig)
    Vue.set(state.originalExpectedNMEAConfigs, id, expectedNMEAConfig)
    state.expectedNMEALoading = false
  },
  [types.GLIDER_IRIS_EXPECTED_NMEA_SAVE_ERROR]: state => {
    state.status = 'error saving expected nmea config'
    state.expectedNMEALoading = false
  },
}
export default mutations
